var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"sticky":true,"fixed":"top","toggleable":"md","type":"dark","variant":"primary"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('span',[_vm._v("GOLS")])]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[(_vm.$store.state.user_obj.first_time_login != '1')?_c('b-navbar-nav',[(
          _vm.$store.state.user_obj &&
          _vm.checkPermission(
            _vm.$store.state.user_obj,
            'Order Management',
            false,
            false,
            _vm.$store.state.user_obj.permissions.nav_order
          )
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Order Management","right":""}},[(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Order Management',
              'Order Master',
              'Order View',
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'order_master', params: {} }}},[_vm._v("Order Master")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Order Management',
              'Order Master',
              'Client Dashboard',
              _vm.$store.state.user_obj.permissions.nav_order
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'client_dashboard', params: {} }}},[_vm._v("Client Dashboard")]):_vm._e(),_vm._v(" "),(
          _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Order Management',
              'Order Inventory',
              false,
              _vm.$store.state.user_obj &&
              _vm.$store.state.user_obj.client_id != '19' &&
              _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'order_inventory', params: {} }}},[_vm._v("Order Inventory")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.$store.state.user_obj.permissions.nav_shopify_order &&
            _vm.$store.state.user_obj.user_name != 'litomon_client' &&
            _vm.$store.state.user_obj.user_name != 'kwh_client'
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'shopify_orders', params: {} }}},[_vm._v("Shopify Orders")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Order Management',
              'Back Order',
              false,
              _vm.$store.state.user_obj.user_name != 'armubuy_client' &&
                _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'back_orders', params: {} }}},[_vm._v("Back Order")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Order Management',
              'Committed Product',
              false,
              _vm.$store.state.user_obj.permissions.nav_committed_products &&
                _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'committed_products', params: {} }}},[_vm._v("Committed Product")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.user_id != '1094' && 
          _vm.checkPermission(
            _vm.$store.state.user_obj,
            'Delivery Management',
            false,
            false,
            _vm.$store.state.user_obj.permissions.nav_tracking
          )
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Delivery Management","right":""}},[(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Delivery Status',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'trackings', params: {} }}},[_vm._v("Delivery Status")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'International Tracking',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'international_tracking', params: {} }}},[_vm._v("International Tracking")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Redemption Status',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'redemption_status', params: {} }}},[_vm._v("Redemption Status")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Delivery Note',
              false,
              _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'delivery_note', params: {} }}},[_vm._v("Delivery Note")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Collection Note',
              false,
              _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'collection_note', params: {} }}},[_vm._v("Collection Note")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.$store.state.user_obj.permissions.route_allocation &&
            _vm.$store.state.user_obj.user_name != 'litomon_client'
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'route_allocation', params: {} }}},[_vm._v("Route Allocation")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.$store.state.user_obj.permissions.route_allocation &&
            _vm.$store.state.user_obj.user_name != 'litomon_client'
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'external_route_allocation', params: {} }}},[_vm._v("External Route Allocation")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.$store.state.user_obj.permissions.route_allocation &&
            _vm.$store.state.user_obj.user_name != 'litomon_client'
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'external_route_allocation_v2', params: {} }}},[_vm._v("External Route Allocation V2")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Reschedule Delivery',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'reschedule_delivery', params: {} }}},[_vm._v("Reschedule Delivery")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Route Update',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'route_update', params: {} }}},[_vm._v("Route Update")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Auto Route Assignment',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'auto_route_assignment', params: {} }}},[_vm._v("Auto Route Assignment")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            (_vm.$store.state.user_obj.account_type == 'client_admin' ||
            _vm.$store.state.user_obj.account_type == 'driver_route')
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'delivery_dashboard', params: {} }}},[_vm._v("Delivery Dashboard")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Tracking SMS',
              false,
              _vm.$store.state.user_obj.permissions.nav_tracking_sms
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'tracking_sms', params: {}}}},[_vm._v("Tracking SMS")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Tracking Return Process',
              false,
              _vm.$store.state.user_obj.permissions.nav_tracking_return_process
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'tracking_return_process', params: {}}}},[_vm._v("Tracking Return Process")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.user_id == '1297'
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Delivery Management","right":""}},[(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Delivery Status',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'trackings', params: {} }}},[_vm._v("Delivery Status")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.$store.state.user_obj.permissions.route_allocation &&
            _vm.$store.state.user_obj.user_name != 'litomon_client'
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'route_allocation', params: {} }}},[_vm._v("Route Allocation")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Reschedule Delivery',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'reschedule_delivery', params: {} }}},[_vm._v("Reschedule Delivery")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Route Update',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'route_update', params: {} }}},[_vm._v("Route Update")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Delivery Management',
              'Auto Route Assignment',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'auto_route_assignment', params: {} }}},[_vm._v("Auto Route Assignment")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            (_vm.$store.state.user_obj.account_type == 'client_admin' ||
            _vm.$store.state.user_obj.account_type == 'driver_route')
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'delivery_dashboard', params: {} }}},[_vm._v("Delivery Dashboard")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.nav_driver_route
        )?_c('b-nav-item',{attrs:{"to":{ name: 'route_allocation', params: {} }}},[_vm._v("Route Allocation")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.nav_vendor_orders
        )?_c('b-nav-item',{attrs:{"to":{ name: 'vendor_orders', params: {} }}},[_vm._v("Orders")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.checkPermission(
            _vm.$store.state.user_obj,
            'Vendor Management',
            false,
            false,
            _vm.$store.state.user_obj.permissions.nav_vendor
          )
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Vendor Management","right":""}},[(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Vendor Management',
              'Order View',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'vendor_orders', params: {} }}},[_vm._v("Order View")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Vendor Management',
              'Product View',
              false,
              _vm.$store.state.user_obj.account_type != 'vendor_warehouse'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'vendor_products', params: {} }}},[_vm._v("Product View")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.checkPermission(
            _vm.$store.state.user_obj,
            'Customer Service',
            false,
            false,
            _vm.$store.state.user_obj.permissions.nav_customer_service
          )
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Customer Service","right":""}},[(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Customer Service',
              'Delivery Case',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'change_requests', params: {} }}},[_vm._v("Delivery Case")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Customer Service',
              'Other Case',
              false,
              _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'cs_issues', params: {} }}},[_vm._v("CS Case")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.checkPermission(
            _vm.$store.state.user_obj,
            'Warehouse Management',
            false,
            false,
            _vm.$store.state.user_obj.permissions.nav_inventory
          )
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Warehouse Management","right":""}},[(
          false && 
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Inventory - Dashboard',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'stock_take_job', params: {} }}},[_vm._v("Stock Take Job")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Inventory - Dashboard',
              false,
              _vm.$store.state.user_obj.user_name != 'neoderm_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'inventory_control', params: {} }}},[_vm._v("Inventory - Dashboard")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Inventory - Transactions',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'wms_transactions', params: {} }}},[_vm._v("Inventory - Transactions")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Inventory - Detailed View',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'wms_products', params: {} }}},[_vm._v("Inventory - Detailed View")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Inventory - Cross-Platform Transfer',
              false,
              _vm.$store.state.user_obj.permissions.nav_cp_transfer
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'inventory_crossplatform_transfer', params: {} }}},[_vm._v("Inventory - Cross-Platform Transfer")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Stock-in Process',
              false,
              _vm.$store.state.user_obj.permissions.nav_stockin_process &&
                _vm.$store.state.user_obj.user_name != 'litomon_client' &&
                _vm.$store.state.user_obj.user_name != 'neoderm_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'stockin_process', params: {} }}},[_vm._v("Stock-in Process")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Fulfilment Process',
              false,
              _vm.$store.state.user_obj.permissions.nav_fulfilment_process &&
                _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'fulfillment_process_v2', params: {} }}},[_vm._v("Fulfillment Process")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Inbound Shipments',
              false,
              _vm.$store.state.user_obj.permissions.nav_inbound_shipment
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'inbound_shipments', params: {} }}},[_vm._v("Inbound Shipments")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Picking Status',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'picking_status', params: {} }}},[_vm._v("Picking Status")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Carton Amendment',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'carton_amendment', params: {} }}},[_vm._v("Carton Amendment")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Print PDF Portal',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'print_pdf_portal', params: {} }}},[_vm._v("Print PDF Portal")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Packing Queue',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'packing_queue', params: {} }}},[_vm._v("Packing Queue")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Packing Process',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'packing_process', params: {} }}},[_vm._v("Packing Log")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Warehouse Management',
              'Fulfilment Process',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'productLocationBulk', params: {} }}},[_vm._v("Bulk Edit Pickup Location")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.checkPermission(
            _vm.$store.state.user_obj,
            'Controls',
            false,
            false,
            _vm.$store.state.user_obj.permissions.nav_control
          )
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Controls","right":""}},[(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Controls',
              'SKU Master',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'product_master', params: {} }}},[_vm._v("SKU Master")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Controls',
              'SKU Master',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'packing_sector_product_priority', params: {} }}},[_vm._v("Packing Sector Priority")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Controls',
              'Location Master',
              false,
              _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'wms_locations', params: {} }}},[_vm._v("Location Master")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Controls',
              'Virtual Kit Master',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'virtual_kit_master', params: {} }}},[_vm._v("Virtual Kit Master")]):_vm._e(),_vm._v(" "),(
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Controls',
              'Virtual Kit Master',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'virtual_kit_reverse_master', params: {} }}},[_vm._v("Reverse Virtual Kit Master")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Controls',
              'Vendor Master',
              false,
              _vm.$store.state.user_obj.permissions.nav_vendor &&
                _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'vendor_master', params: {} }}},[_vm._v("Vendor Master")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Controls',
              'Redemption Location Master',
              false,
              _vm.$store.state.user_obj.user_name != 'litomon_client'
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'redemption_location_master', params: {} }}},[_vm._v("Redemption Location Master")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'address_template', params: {} }}},[_vm._v("Address Template Master")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.client_id == 3 &&
          _vm.$store.state.user_obj.account_type == 'admin'
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Config","right":""}},[_c('b-dropdown-item',{attrs:{"to":{ name: 'cms_client', params: {} }}},[_vm._v("Clients")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'cms_client_setup', params: {} }}},[_vm._v("Client Setup")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'bot_schedule_exceptions', params: {} }}},[_vm._v("AML BOT")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'hktvmall_manual_upload', params: {} }}},[_vm._v("HKTVmall Manual Upload")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'sf_shipment_quota_dashboard', params: {} }}},[_vm._v("SF Dashboard")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'auto_route_assignment', params: {} }}},[_vm._v("Auto Route Assignment")])],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.checkPermission(
            _vm.$store.state.user_obj,
            'Account',
            false,
            false,
            false
          )
        )?_c('b-nav-item-dropdown',{attrs:{"text":"Account","right":""}},[(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Account',
              false,
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'cms_account', params: {} }}},[_vm._v("Account")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Account',
              'Client',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'cms_client', params: {} }}},[_vm._v("Client")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Account',
              'Permission Group',
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'cms_permission_group', params: {} }}},[_vm._v("Permission Group")]):_vm._e(),_vm._v(" "),(
          false && 
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Account',
              false,
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'cms_change_log', params: {} }}},[_vm._v("Change Log")]):_vm._e(),_vm._v(" "),(
            _vm.$store.state.user_obj &&
            _vm.checkPermission(
              _vm.$store.state.user_obj,
              'Account',
              false,
              false,
              true
            )
          )?_c('b-dropdown-item',{attrs:{"to":{ name: 'cms_barcode_reader', params: {} }}},[_vm._v("Test Barcode Reader")]):_vm._e()],1):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.nav_drivers
        )?_c('b-nav-item',{attrs:{"to":{ name: 'drivers', params: {} }}},[_vm._v("Drivers")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj && _vm.$store.state.user_obj.permissions.nav_users
        )?_c('b-nav-item',{attrs:{"to":{ name: 'users', params: {} }}},[_vm._v("Users")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.nav_clients
        )?_c('b-nav-item',{attrs:{"to":{ name: 'clients', params: {} }}},[_vm._v("Clients")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.nav_hkt_orders
        )?_c('b-nav-item',{attrs:{"to":{ name: 'hkt_orders', params: {} }}},[_vm._v("Orders")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.nav_cpr_orders
        )?_c('b-nav-item',{attrs:{"to":{ name: 'cpr_orders', params: {} }}},[_vm._v("Orders")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.cms_category
        )?_c('b-nav-item',{attrs:{"to":{ name: 'cms_category', params: {} }}},[_vm._v("Category")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.cms_product
        )?_c('b-nav-item',{attrs:{"to":{ name: 'cms_product', params: {} }}},[_vm._v("Product")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          (_vm.$store.state.user_obj.account_type == 'sleb_regional' ||
            _vm.$store.state.user_obj.account_type == 'sleb_admin')
        )?_c('b-nav-item',{attrs:{"to":{ name: 'cms_banner', params: {} }}},[_vm._v("Banner")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj && _vm.$store.state.user_obj.permissions.cms_order
        )?_c('b-nav-item',{attrs:{"to":{ name: 'cms_order', params: {} }}},[_vm._v("Order")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.cms_report
        )?_c('b-nav-item',{attrs:{"to":{ name: 'cms_report', params: {} }}},[_vm._v("Report")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.cms_report
        )?_c('b-nav-item',{attrs:{"to":{ name: 'cms_payment', params: {} }}},[_vm._v("Payment")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.user_obj &&
          _vm.$store.state.user_obj.permissions.nav_redemption_center
        )?_c('b-nav-item',{attrs:{"to":{ name: 'redemption_center', params: {} }}},[_vm._v("Ready for Pickup")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[(_vm.$store.state.user_obj)?_c('b-nav-item',[_c('small',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$store.state.user_obj.name))])]):_vm._e(),_vm._v(" "),(_vm.$store.state.user_obj)?_c('b-nav-item',{on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6729e5bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 